import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { toast } from 'react-hot-toast';

export default function AmazonCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { currentUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const state = searchParams.get('state');
        const storedState = localStorage.getItem('amazonOAuthState');
        const spapi_oauth_code = searchParams.get('spapi_oauth_code');

        // Verify state to prevent CSRF
        if (!state || state !== storedState) {
          throw new Error('Invalid state parameter');
        }

        if (!spapi_oauth_code) {
          throw new Error('No authorization code received');
        }

        if (!currentUser?.companyId) {
          throw new Error('User not authenticated');
        }

        // Store the authorization code in Firestore
        await setDoc(doc(db, 'multicanal', currentUser.companyId), {
          amazon: {
            active: true,
            oauthCode: spapi_oauth_code,
            connectedAt: new Date().toISOString(),
          }
        }, { merge: true });

        // Clean up
        localStorage.removeItem('amazonOAuthState');
        
        toast.success('Conta Amazon conectada com sucesso');
        navigate('/dashboard/multicanal/settings');
      } catch (error) {
        console.error('Error in Amazon callback:', error);
        toast.error('Erro ao conectar com a Amazon');
        navigate('/dashboard/multicanal/settings?error=auth_failed');
      }
    };

    handleCallback();
  }, [searchParams, navigate, currentUser]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">A processar autenticação...</h2>
        <p className="text-gray-600">Por favor, aguarde.</p>
      </div>
    </div>
  );
}
